// ##### 25-02-05 Komarov
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useSelector } from 'react-redux';
// ##### 25-05-21 Komarov
import LocalizationNavLink from '../../../Library/Localization/LocalizationNavLink';

// ##### Komarov 2025-07-14
const AllCitiesList = ({
  style = null,
  /* cities_overview_all_data, */ countryLocalized,
}) => {
  // ##### 25-04-21 Komarov
  const language = useSelector(state => state.language);
  const cities_overview_all_data = useSelector(
    state => state.cities.cities_overview_all[language].data[0].data.object_list
  );

  return (
    <ul style={style}>
      {cities_overview_all_data.map(page => {
        return (
          <li key={uniqueId()}>
            <LocalizationNavLink
              // ##### 25-04-21 Komarov
              to={`/city_overview/?name=${page.object_name
                .toLowerCase()
                .replace(/\s/g, '-')
                .toLowerCase()}&spid=${page.sitepageobject_id}&sptid=${page.type_id
                }`}
            >
              {/* ##### 24-07-24 Komarov */}
              {page.object_langname}, {countryLocalized}
            </LocalizationNavLink>
          </li>
        );
      })}
    </ul>
  );
};

export default AllCitiesList;
